export const SET_USER = 'SET_USER';
export const SET_SCREEN = 'SET_SCREEN';
export const CLEAR = 'CLEAR';
export const SET_ROUTE = 'SET_ROUTE';
export const SET_STORE = 'SET_STORE';
